import { Colors } from '../Colors';

export const Variables = {
  typoTextFsXXS: 'var(--typo-text-fs-xxs, 1.2rem)',
  typoTextLhXXS: 'var(--typo-text-lh-xxs, 1.5)', // 18

  typoTextFsXS: 'var(--typo-text-fs-xs, 1.2rem)',
  typoTextLhXS: 'var(--typo-text-lh-xs, 1.66)', // 20

  typoTextFsXSCH: 'var(--typo-text-fs-xsch, 1.2rem)',
  typoTextLhXSCH: 'var(--typo-text-lh-xsch, 1.5)', // 18

  typoTextFsS: 'var(--typo-text-fs-s, 1.3rem)',
  typoTextLhS: 'var(--typo-text-lh-s, 1.53)', // 20

  typoTextFsSCH: 'var(--typo-text-fs-sch, 1.3rem)',
  typoTextLhSCH: 'var(--typo-text-lh-sch, 1.38)', // 18

  typoTextFsM: 'var(--typo-text-fs-m, 1.4rem)',
  typoTextLhM: 'var(--typo-text-lh-m, 1.42)', // 20

  typoTextFsMCH: 'var(--typo-text-fs-mch, 1.4rem)',
  typoTextLhMCH: 'var(--typo-text-lh-mch, 1.28)', // 18

  typoTextFsL: 'var(--typo-text-fs-l, 1.7rem)',
  typoTextLhL: 'var(--typo-text-lh-l, 1.41)', // 24

  typoTextFsXL: 'var(--typo-text-fs-xl, 2.2rem)',
  typoTextLhXL: 'var(--typo-text-lh-xl, 1.27)', // 28

  typoTextFsXXL: 'var(--typo-text-fs-xxl, 3rem)',
  typoTextLhXXL: 'var(--typo-text-lh-xxl, 1.2)', // 36

  typoTextFsXXXL: 'var(--typo-text-fs-xxxl, 4.8rem)',
  typoTextLhXXXL: 'var(--typo-text-lh-xxxl, 1.25)', // 60

  tooltipShadow: `var(--tooltip-shadow, 0 1rem 3rem ${Colors.ut.shadow10}), 0 0 0 1px ${Colors.ut.shadow10}`,
  tooltipRadius: 'var(--tooltip-radius, 0.8rem)',
  popupShadow: `var(--popup-shadow, 0 0.4rem 1.4rem ${Colors.ut.shadow10}, 0 1.1rem 6rem ${Colors.ut.shadow10})`,
  popupRadius: 'var(--popup-radius, 0.8rem)',
  shimmerRadius: 'var(--shimmer-radius, 0.3rem)',
  inputRadius: 'var(--input-radius, 0.8rem)',
  hintRadius: 'var(--hint-radius, 0.8rem)',
  tagRadius: 'var(--tag-radius, 0.3rem)'
};
